// Ordagrant de fraser live-widgeten får av askas admin (data-phrase-* i
// chat_embed.tt, hämtade från respektive sajts startsida 2026-09-24). Ändras
// en fras i admin ska den ändras här också, annars visar playgrounden något
// annat än kunden ser.
export type CardPhrases = {
  locale: string;
  order: string;
  total: string;
  noUpdate: string;
  noTrackingLink: string;
  trackParcel: string;
  trackCarrier: string;
  seeWholeOrder: string;
  factMethod: string;
  factWindow: string;
  factTracking: string;
  factAddress: string;
  events: string;
  updated: string;
  updatedJustNow: string;
  returnScopePartial: string;
  returnScopeFull: string;
  showItems: string;
  hideItems: string;
  trackingTitle: string;
  itemSingular: string;
  itemPlural: string;
  steps: Record<string, string>;
};

const sv: CardPhrases = {
  locale: 'sv-SE',
  order: 'Order',
  total: 'Totalt',
  noUpdate: 'Ingen uppdatering än',
  noTrackingLink: 'Ingen spårningslänk än',
  trackParcel: 'Spåra paketet',
  trackCarrier: 'Spåra hos transportören',
  seeWholeOrder: 'Se hela ordern',
  factMethod: 'Fraktsätt',
  factWindow: 'Leveransfönster',
  factTracking: 'Spårningsnummer',
  factAddress: 'Leveransadress',
  events: 'Händelser',
  updated: 'Uppdaterad',
  updatedJustNow: 'Uppdaterad nyss',
  returnScopePartial: 'Delvis retur',
  returnScopeFull: 'Hel retur',
  showItems: 'Visa plagg',
  hideItems: 'Dölj plagg',
  trackingTitle: 'Spårning',
  itemSingular: 'plagg',
  itemPlural: 'plagg',
  steps: {
    paid: 'Betald',
    packed: 'Packad',
    shipped: 'Skickad',
    delivered: 'Levererad',
    registered: 'Registrerad',
    picked_up: 'Hämtad',
    in_transit: 'På väg',
    ready_for_pickup: 'Redo för uthämtning',
    received: 'Mottagen',
    refunded: 'Återbetald',
  },
};

const en: CardPhrases = {
  locale: 'en-GB',
  order: 'Order',
  total: 'Total',
  noUpdate: 'No update yet',
  noTrackingLink: 'No tracking link yet',
  trackParcel: 'Track the parcel',
  trackCarrier: 'Track with the carrier',
  seeWholeOrder: 'See the whole order',
  factMethod: 'Shipping method',
  factWindow: 'Delivery window',
  factTracking: 'Tracking number',
  factAddress: 'Delivery address',
  events: 'Events',
  updated: 'Updated',
  updatedJustNow: 'Updated just now',
  returnScopePartial: 'Partial return',
  returnScopeFull: 'Full return',
  showItems: 'Show garments',
  hideItems: 'Hide garments',
  trackingTitle: 'Tracking',
  itemSingular: 'garments',
  itemPlural: 'garments',
  steps: {
    paid: 'Paid',
    packed: 'Packed',
    shipped: 'Shipped',
    delivered: 'Delivered',
    registered: 'Registered',
    picked_up: 'Picked up',
    in_transit: 'In transit',
    ready_for_pickup: 'Ready for pickup',
    received: 'Received',
    refunded: 'Refunded',
  },
};

const de: CardPhrases = {
  locale: 'de-DE',
  order: 'Bestellung',
  total: 'Insgesamt',
  noUpdate: 'Noch keine Aktualisierung',
  noTrackingLink: 'Noch kein Sendungsverfolgungslink',
  trackParcel: 'Paket verfolgen',
  trackCarrier: 'Beim Transportunternehmen verfolgen',
  seeWholeOrder: 'Gesamte Bestellung ansehen',
  factMethod: 'Versandart',
  factWindow: 'Lieferzeitfenster',
  factTracking: 'Sendungsnummer',
  factAddress: 'Lieferadresse',
  events: 'Ereignisse',
  updated: 'Aktualisiert',
  updatedJustNow: 'Gerade aktualisiert',
  returnScopePartial: 'Teilweise Rücksendung',
  returnScopeFull: 'Vollständige Rücksendung',
  showItems: 'Kleidungsstücke anzeigen',
  hideItems: 'Kleidungsstücke ausblenden',
  trackingTitle: 'Sendungsverfolgung',
  itemSingular: 'Kleidungsstücke',
  itemPlural: 'Kleidungsstücke',
  steps: {
    paid: 'Bezahlt',
    packed: 'Verpackt',
    shipped: 'Versandt',
    delivered: 'Geliefert',
    registered: 'Registriert',
    picked_up: 'Abgeholt',
    in_transit: 'Unterwegs',
    ready_for_pickup: 'Bereit zur Abholung',
    received: 'Erhalten',
    refunded: 'Erstattet',
  },
};

const fr: CardPhrases = {
  locale: 'fr-FR',
  order: 'Commande',
  total: 'Total',
  noUpdate: "Aucune mise à jour pour l'instant",
  noTrackingLink: "Aucun lien de suivi pour l'instant",
  trackParcel: 'Suivre le colis',
  trackCarrier: 'Suivre chez le transporteur',
  seeWholeOrder: 'Voir toute la commande',
  factMethod: 'Mode de livraison',
  factWindow: 'Créneau de livraison',
  factTracking: 'Numéro de suivi',
  factAddress: 'Adresse de livraison',
  events: 'Événements',
  updated: 'Mis à jour',
  updatedJustNow: "Mis à jour à l'instant",
  returnScopePartial: 'Retour partiel',
  returnScopeFull: 'Retour complet',
  showItems: 'Afficher les vêtements',
  hideItems: 'Masquer les vêtements',
  trackingTitle: 'Suivi',
  itemSingular: 'vêtements',
  itemPlural: 'vêtements',
  steps: {
    paid: 'Payé',
    packed: 'Emballé',
    shipped: 'Expédié',
    delivered: 'Livré',
    registered: 'Enregistré',
    picked_up: 'Retiré',
    in_transit: 'En transit',
    ready_for_pickup: 'Prêt à être retiré',
    received: 'Reçu',
    refunded: 'Remboursé',
  },
};

const da: CardPhrases = {
  locale: 'da-DK',
  order: 'Ordre',
  total: 'Total',
  noUpdate: 'Ingen opdatering endnu',
  noTrackingLink: 'Intet sporingslink endnu',
  trackParcel: 'Spor pakken',
  trackCarrier: 'Spor hos transportøren',
  seeWholeOrder: 'Se hele ordren',
  factMethod: 'Forsendelsesmetode',
  factWindow: 'Leveringsvindue',
  factTracking: 'Sporingsnummer',
  factAddress: 'Leveringsadresse',
  events: 'Hændelser',
  updated: 'Opdateret',
  updatedJustNow: 'Opdateret lige nu',
  returnScopePartial: 'Delvis retur',
  returnScopeFull: 'Fuld retur',
  showItems: 'Vis beklædningsdele',
  hideItems: 'Skjul beklædningsdele',
  trackingTitle: 'Sporing',
  itemSingular: 'beklædningsdele',
  itemPlural: 'beklædningsdele',
  steps: {
    paid: 'Betalt',
    packed: 'Pakket',
    shipped: 'Sendt',
    delivered: 'Leveret',
    registered: 'Registreret',
    picked_up: 'Afhentet',
    in_transit: 'På vej',
    ready_for_pickup: 'Klar til afhentning',
    received: 'Modtaget',
    refunded: 'Tilbagebetalt',
  },
};

const no: CardPhrases = {
  locale: 'nb-NO',
  order: 'Ordre',
  total: 'Totalt',
  noUpdate: 'Ingen oppdatering ennå',
  noTrackingLink: 'Ingen sporingslenke ennå',
  trackParcel: 'Spor pakken',
  trackCarrier: 'Spor hos transportøren',
  seeWholeOrder: 'Se hele ordren',
  factMethod: 'Fraktmåte',
  factWindow: 'Leveringsvindu',
  factTracking: 'Sporingsnummer',
  factAddress: 'Leveringsadresse',
  events: 'Hendelser',
  updated: 'Oppdatert',
  updatedJustNow: 'Oppdatert nå nettopp',
  returnScopePartial: 'Delvis retur',
  returnScopeFull: 'Full retur',
  showItems: 'Vis plagg',
  hideItems: 'Skjul plagg',
  trackingTitle: 'Sporing',
  itemSingular: 'plagg',
  itemPlural: 'plagg',
  steps: {
    paid: 'Betalt',
    packed: 'Pakket',
    shipped: 'Sendt',
    delivered: 'Levert',
    registered: 'Registrert',
    picked_up: 'Hentet',
    in_transit: 'På vei',
    ready_for_pickup: 'Klar for henting',
    received: 'Mottatt',
    refunded: 'Tilbakebetalt',
  },
};

const fi: CardPhrases = {
  locale: 'fi-FI',
  order: 'Tilaus',
  total: 'Yhteensä',
  noUpdate: 'Ei vielä päivitystä',
  noTrackingLink: 'Ei vielä seurantalinkkiä',
  trackParcel: 'Seuraa pakettia',
  trackCarrier: 'Seuraa kuljetusyhtiön sivuilla',
  seeWholeOrder: 'Katso koko tilaus',
  factMethod: 'Toimitustapa',
  factWindow: 'Toimitusikkuna',
  factTracking: 'Seurantanumero',
  factAddress: 'Toimitusosoite',
  events: 'Tapahtumat',
  updated: 'Päivitetty',
  updatedJustNow: 'Päivitetty juuri nyt',
  returnScopePartial: 'Osittainen palautus',
  returnScopeFull: 'Koko palautus',
  showItems: 'Näytä vaatteet',
  hideItems: 'Piilota vaatteet',
  trackingTitle: 'Seuranta',
  itemSingular: 'vaatetta',
  itemPlural: 'vaatetta',
  steps: {
    paid: 'Maksettu',
    packed: 'Pakattu',
    shipped: 'Lähetetty',
    delivered: 'Toimitettu',
    registered: 'Rekisteröity',
    picked_up: 'Noudettu',
    in_transit: 'Matkalla',
    ready_for_pickup: 'Valmis noudettavaksi',
    received: 'Vastaanotettu',
    refunded: 'Hyvitetty',
  },
};

const nl: CardPhrases = {
  locale: 'nl-NL',
  order: 'Bestelling',
  total: 'Totaal',
  noUpdate: 'Nog geen update',
  noTrackingLink: 'Nog geen trackinglink',
  trackParcel: 'Volg het pakket',
  trackCarrier: 'Volgen bij de vervoerder',
  seeWholeOrder: 'Bekijk de hele bestelling',
  factMethod: 'Verzendmethode',
  factWindow: 'Bezorgvenster',
  factTracking: 'Trackingnummer',
  factAddress: 'Leveringsadres',
  events: 'Gebeurtenissen',
  updated: 'Bijgewerkt',
  updatedJustNow: 'Zojuist bijgewerkt',
  returnScopePartial: 'Gedeeltelijke retour',
  returnScopeFull: 'Volledige retour',
  showItems: 'Kledingstukken tonen',
  hideItems: 'Kledingstukken verbergen',
  trackingTitle: 'Tracking',
  itemSingular: 'kledingstukken',
  itemPlural: 'kledingstukken',
  steps: {
    paid: 'Betaald',
    packed: 'Ingepakt',
    shipped: 'Verzonden',
    delivered: 'Geleverd',
    registered: 'Geregistreerd',
    picked_up: 'Opgehaald',
    in_transit: 'Onderweg',
    ready_for_pickup: 'Klaar voor afhaling',
    received: 'Ontvangen',
    refunded: 'Terugbetaald',
  },
};

const es: CardPhrases = {
  locale: 'es-ES',
  order: 'Pedido',
  total: 'Total',
  noUpdate: 'Aún sin actualización',
  noTrackingLink: 'Aún sin enlace de seguimiento',
  trackParcel: 'Seguir el paquete',
  trackCarrier: 'Seguir con el transportista',
  seeWholeOrder: 'Ver el pedido completo',
  factMethod: 'Método de envío',
  factWindow: 'Franja de entrega',
  factTracking: 'Número de seguimiento',
  factAddress: 'Dirección de entrega',
  events: 'Eventos',
  updated: 'Actualizado',
  updatedJustNow: 'Actualizado ahora mismo',
  returnScopePartial: 'Devolución parcial',
  returnScopeFull: 'Devolución completa',
  showItems: 'Ver prendas',
  hideItems: 'Ocultar prendas',
  trackingTitle: 'Seguimiento',
  itemSingular: 'prendas',
  itemPlural: 'prendas',
  steps: {
    paid: 'Pagado',
    packed: 'Empaquetado',
    shipped: 'Enviado',
    delivered: 'Entregado',
    registered: 'Registrado',
    picked_up: 'Recogido',
    in_transit: 'En tránsito',
    ready_for_pickup: 'Listo para recogida',
    received: 'Recibido',
    refunded: 'Reembolsado',
  },
};

const it: CardPhrases = {
  locale: 'it-IT',
  order: 'Ordine',
  total: 'Totale',
  noUpdate: 'Nessun aggiornamento ancora',
  noTrackingLink: 'Nessun link di tracciamento ancora',
  trackParcel: 'Traccia il pacco',
  trackCarrier: 'Traccia presso il corriere',
  seeWholeOrder: "Vedi l'intero ordine",
  factMethod: 'Metodo di spedizione',
  factWindow: 'Finestra di consegna',
  factTracking: 'Numero di tracciamento',
  factAddress: 'Indirizzo di consegna',
  events: 'Eventi',
  updated: 'Aggiornato',
  updatedJustNow: 'Aggiornato proprio ora',
  returnScopePartial: 'Reso parziale',
  returnScopeFull: 'Reso completo',
  showItems: 'Mostra capi',
  hideItems: 'Nascondi capi',
  trackingTitle: 'Tracciamento',
  itemSingular: 'capi',
  itemPlural: 'capi',
  steps: {
    paid: 'Pagato',
    packed: 'Imballato',
    shipped: 'Spedito',
    delivered: 'Consegnato',
    registered: 'Registrato',
    picked_up: 'Ritirato',
    in_transit: 'In transito',
    ready_for_pickup: 'Pronto per il ritiro',
    received: 'Ricevuto',
    refunded: 'Rimborsato',
  },
};

const CARD_PHRASES_BY_LANGUAGE: Record<string, CardPhrases> = {
  sv,
  en,
  de,
  fr,
  da,
  no,
  fi,
  nl,
  es,
  it,
};

export const cardPhrasesFor = (language?: string): CardPhrases =>
  CARD_PHRASES_BY_LANGUAGE[String(language ?? '').toLowerCase()] ?? sv;
